import React from 'react';
import {transactionsExchangeStore} from "../../../store/TransactionsExchange";
import {BaseMatchedTransaction} from "../../../model/MatchedDocument";
import TransactionTablesComponent from "./TransactionTablesComponent";
import {Grid, Paper, Typography} from "@mui/material";
import {BankAccountCode} from "../../../model/BankAccountCode";


interface IProps {
    id: string
}

interface IState {
    bank?: BankAccountCode,
    txs?: BaseMatchedTransaction[],
}

class TransactionsPreviewForPrinting extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {}
    }

    async componentDidMount() {
        const data = transactionsExchangeStore.getTransactions(this.props.id)!!
        this.setState({
            bank: data.bank,
            txs: data.txs
        })
    }

    render() {
        const {txs, bank} = this.state;
        if (txs && bank) {
            return (
                <Grid container>
                    <TransactionTablesComponent
                        bank={bank}
                        showActions={false}
                        showHiddenColumns={false}
                        transactions={txs}
                        itemWrapper={(description, table) => {
                            return <Grid item xs={12}>
                                <Paper style={{paddingTop: "1rem"}}>
                                    <Typography variant={"h5"}>{description}</Typography>
                                    {table}
                                </Paper>
                            </Grid>
                        }}
                    />
                </Grid>
            );
        } else {
            return <>
            </>
        }
    }
}

export default TransactionsPreviewForPrinting;